export default "__VITE_ASSET__D818gRsW__"